import { handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const TOGGLE_MARKET = "app/userMarkets/TOGGLE_MARKET";

export const getUserMarkets = createRoutine("app/userMarkets/GET_USER_MARKETS");
export const toggleMarket = createRoutine(TOGGLE_MARKET);
export const setUserMarkets = createRoutine("app/userMarkets/SET_USER_MARKETS");

export const initialState = {
  markets: null,
  loading: false
};

export default handleActions(
  {
    [getUserMarkets.TRIGGER]: state => ({
      ...state,
      loading: true
    }),
    [getUserMarkets.SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        loading: false,
        markets: payload.data
      };
    },
    [toggleMarket.SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        markets: payload.data
      };
    }
  },
  initialState
);
